import merge from 'lodash/merge';
import config from '../../config';
import RestEntityAPI from './restEntityAPI';

const options = {
  entityName: 'dashboard',
  endpoint: `${config.apiUrl}/v1/dashboard/`,
  searchEndpoint: `${config.apiUrl}/v1/dashboard/search`,
};

const DashboardAPI = () => {
  const parentAPI = RestEntityAPI(options);

  return merge({}, { ...parentAPI }, {

  });
};

export default DashboardAPI;
